<template>
    <vx-card class="mb-0">
        <div class="container mx-auto px-4">
            <div class="mb-4 mt-5">

                <h4>Seleccione uno o varios periodos para el reporte</h4>
                <v-select multiple :options="arrayPeriodos" label="periodoescolar" :reduce="p => p.idperiodoescolar"
                    v-model="periodoSelect" class="w-full multi-select-height" @input="f_get_pedidos_periodos" />
            </div>

            <!-- Tabla de Reportes CORREGIDA -->
            <div class="mt-8 overflow-x-auto">
                <table class="min-w-full bg-white border border-gray-200">
                    <thead>
                        <tr class="bg-gray-100">
                            <th class="py-2 px-4 border-b text-left">Institucion</th>
                            <th class="py-2 px-4 border-b text-left">Convenio</th>
                            <th class="py-2 px-4 border-b text-left">Pagos</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="pedidos.length === 0">
                            <td colspan="4" class="text-center py-4 text-gray-500">
                                No hay pedidos para mostrar
                            </td>
                        </tr>
                        <tr v-for="pedido in pedidos" :key="pedido.id_pedido" class="hover:bg-gray-50">
                            <td class="py-2 px-4 border-b">
                                <p> # {{ pedido.id_pedido }}</p>
                                <p><small>Pedido: {{ pedido.pedido_institucion_id }} Convenio: {{ pedido.convenio_institucion_id }}</small></p>
                                <p>{{ pedido.nombreInstitucion }}</p>
                                <p>{{ pedido.asesor_nombres }} {{ pedido.asesor_apellidos }}</p>
                                <p>{{ pedido.contrato_generado }}</p>
                                <p>{{ pedido.tipo_venta_descr }}</p>
                                <p>{{ pedido.nombre_periodo }} <small> ({{ pedido.id_periodo }})</small></p>
                            </td>
                            <td>
                                <p>Global: {{ pedido.convenio_global }}</p>
                                <p>Pagado: {{ pedido.valor_convenio_pagado }}</p>
                                <p>Suma pagos: {{ pedido.total_pagado_aprobado }}</p>
                                <p>Pagos pendientes: {{ pedido.total_pagado_pendiente }}</p>
                                <p>suma_total_pagos: {{ pedido.suma_total_pagos }}</p>
                                <p>Tiempo: {{ pedido.convenio_anios }} años</p>
                                <p>Inicio: {{ pedido.inicio_convenio }}</p>
                                <p>Estado: {{ pedido.estado_convenio }}</p>
                                <p>doc_observacion: {{ pedido.doc_observacion }}</p>
                                <p>Obs: {{ pedido.observacion }}</p>
                            </td>
                            <td></td>

                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import Generalmix from '@/mixins/Generalmix';

export default {
    mixins: [Generalmix],
    components: {
        vSelect,
    },
    data() {
        return {
            arrayPeriodos: [],
            periodoSelect: null,
            totalVenta: 0,
            totalVentaDescuento: 0,
            pedidos: [],
        }
    },

    mounted() {
        this.obtenerPeriodos()
    },

    methods: {
        obtenerPeriodos() {
            let me = this;
            this.$http.get(this.$server_url + 'periodo_nombre')
                .then(res => {
                    console.log('Periodos obtenidos:', res.data);
                    me.arrayPeriodos = res.data;
                })
        },
        f_get_pedidos_periodos() {
            console.log('IDs seleccionados:', this.periodoSelect);
            if (!this.periodoSelect || this.periodoSelect.length === 0) {
                console.warn('No hay periodos seleccionados');
                return;
            }

            this.$vs.loading();

            this.$http.post(this.$server_url + 'obtenerPedidosPorPeriodo', {
                periodos: this.periodoSelect // 👈 ya es array de IDs
            })
                .then(res => {
                    console.log('Pedidos:', res.data.data);
                    this.pedidos = res.data.data;
                })
                .catch(err => {
                    console.error('Error:', err);
                })
                .finally(() => {
                    this.$vs.loading.close();
                });
        }
    }
}
</script>

<style scoped>
/* ── KPI Grid ── */
.kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 10px;
    margin-top: 16px;
}

.kpi-card {
    border-radius: 8px;
    padding: 14px 16px;
    border-left: 4px solid transparent;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.kpi-label {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #94a3b8;
    margin-bottom: 5px;
}

.kpi-value {
    font-size: 17px;
    font-weight: 700;
    color: #1e293b;
}

.kpi-blue {
    border-color: #93c5fd;
    background: #eff6ff;
}

.kpi-blue .kpi-value {
    color: #1d4ed8;
}

.kpi-orange {
    border-color: #fdba74;
    background: #fff7ed;
}

.kpi-orange .kpi-value {
    color: #c2410c;
}

.kpi-green {
    border-color: #86efac;
    background: #f0fdf4;
}

.kpi-green .kpi-value {
    color: #15803d;
}

.kpi-purple {
    border-color: #c4b5fd;
    background: #f5f3ff;
}

.kpi-purple .kpi-value {
    color: #6d28d9;
}

.kpi-teal {
    border-color: #5eead4;
    background: #f0fdfa;
}

.kpi-teal .kpi-value {
    color: #0f766e;
}

.kpi-indigo {
    border-color: #a5b4fc;
    background: #eef2ff;
}

.kpi-indigo .kpi-value {
    color: #4338ca;
}

.kpi-cyan {
    border-color: #67e8f9;
    background: #ecfeff;
}

.kpi-cyan .kpi-value {
    color: #0e7490;
}

.kpi-yellow {
    border-color: #fde68a;
    background: #fffbeb;
}

.kpi-yellow .kpi-value {
    color: #b45309;
}

.kpi-red {
    border-color: #fca5a5;
    background: #fef2f2;
}

.kpi-red .kpi-value {
    color: #b91c1c;
}

.kpi-gray {
    border-color: #cbd5e1;
    background: #f8fafc;
}

.kpi-gray .kpi-value {
    color: #334155;
}
</style>